import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ClassFilterTrigger } from "@components/Class/ClassFilter/ClassFilterTrigger";
import { GLViewRow } from "../glViewTypes";

interface TransactionClassRow {
    rowKind: string;
    transaction?: { classIds: string[] };
}

export function TransactionClassCell<Row extends TransactionClassRow>({
    row,
}: CellContext<ViewTableFeatures, Row, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;

    if (
        rowKind !== "transaction" ||
        !transaction ||
        transaction.classIds.length === 0
    ) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <ClassFilterTrigger value={transaction.classIds} />
        </ViewTableCell>
    );
}

export const GLClassCell = React.memo(function GLClassCell(
    props: CellContext<ViewTableFeatures, GLViewRow, unknown>,
): React.ReactElement {
    return <TransactionClassCell {...props} />;
});
